import { forwardRef } from "react";

export const Checkbox = forwardRef((props, ref, type = 'checkbox') => {
    return <input type={type} ref={ref} className="form__field" {...props} />;
});
